import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { FacebookService } from '../services/facebook-sdk.service';

declare global {
    interface Window {
        fbAsyncInit: () => void;
        FB: any;
    }
}

export function facebookSdkInitializer(): () => Promise<void> {
    return () => {
        const facebookService = inject(FacebookService);

        if (typeof window.FB !== 'undefined') {
            facebookService.markSDKReady();
            return Promise.resolve();
        }

        if (document.getElementById('facebook-jssdk')) {
            return Promise.resolve();
        }

        window.fbAsyncInit = function () {
            try {
                window.FB.init({
                    appId: environment.facebook_app_id,
                    cookie: true,
                    xfbml: true,
                    version: 'v25.0',
                });
                window.FB.getLoginStatus((response: any) => {
                    if (response.authResponse) {
                        console.log('Facebook authResponse:', response.authResponse);
                    }
                });
                facebookService.markSDKReady();
            } catch (e) {
                console.error("Facebook SDK: erreur lors de l'initialisation", e);
            }
        };

        const script = document.createElement('script');
        script.id = 'facebook-jssdk';
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.async = true;
        script.defer = true;
        script.onerror = () => console.error('Facebook SDK: échec du chargement');
        document.head.appendChild(script);

        return Promise.resolve();
    };
}
